export default __webpack_public_path__ + "static/media/icon.14554ae1.png";